import React from 'react';
import KitchenPlayerFilterEvents from '../../containers/KitchenPlayer/KitchenPlayerFilterEvents';
import PlayerActivityHistoryRange from './PlayerActivityHistoryRange';
import PlayerActivityHistoryEvents from './PlayerActivityHistoryEvents';
import Search from '../../containers/KitchenHistoryPlayer/components/Search/Search';
import './PlayerActivityHistory.scss';

export const PlayerActivityHistory = ({
  events,
  loadMore,
  historyMode,
  streamsKey,
  availableHistoryRange,
  historyRange,
  setHistoryRange,
}) => {
  return (
    <div className="activity-history-container">
      <div className="activity-history__header">
        <div className="activity-history__header-events">
          <div>Events</div>
          <div>{events.data.length}</div>
        </div>
  
        <div className="activity-history__header-filters">
          <KitchenPlayerFilterEvents historyMode={historyMode} />
          <Search historyMode={historyMode} />
        </div>
      </div>

      {!historyMode && availableHistoryRange ? (
        <PlayerActivityHistoryRange
          availableHistoryRange={availableHistoryRange}
          historyRange={historyRange}
          setHistoryRange={setHistoryRange}
        />
      ) : null}
  
      <PlayerActivityHistoryEvents events={events} loadMore={loadMore} historyMode={historyMode} streamsKey={streamsKey} />
    </div>
  );
};
